import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  Tabs,
  Tab,
  SelectChangeEvent,
  FormControl,
  Select,
  MenuItem,
  Switch,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import * as Yup from "yup";
import { isString, useFormik } from "formik";
import MainContainer from "../../layout/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import { ChangeEvent, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { CommonBody, subAdminRole, subAdminType } from "../../types/General";
import { useAddSubAdminMutation, useAddSubAdminRoleMutation, useDeleteSubAdminRoleMutation, useLazyGetSubAdminByIdQuery, useLazyGetSubAdminRoleQuery, useUpdateSubAdminMutation, useUpdateSubAdminRoleMutation } from "../../services/subAdmin";
import { useLazyGetAllSubCategoriesQuery } from "../../services/categories";
import { showError, showToast } from "../../constants/toast";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { WarnModal } from "../../components";
import { UploadMedia } from "../../utils/mediaUpload";

interface DataType {
  _id?: string;
  label: string;
  isEdit: boolean;
  isView: boolean;
  isDelete?: boolean;
  disabled?: boolean;
}



const AddSubAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [location, setLocation] = useState("");
  const [rolesData, setRolesData] = useState<subAdminRole[]>([]);
  const [newRole, setNewRole] = useState("");
  const [fileName, setFileName] = useState<string>("");
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [newData, setNewData] = useState<DataType[]>([] as any);

  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [value, setValue] = useState<number>(0);
  const [addRole] = useAddSubAdminRoleMutation();
  const [image, setImage] = useState<string>("");
  const [phoneCode, setPhoneCode] = useState("+91");
  const [getAllRole] = useLazyGetSubAdminRoleQuery();
  const [updateStatusOfRole] = useUpdateSubAdminRoleMutation();
  const [deleteRole] = useDeleteSubAdminRoleMutation();
  const [addSubAdmin] = useAddSubAdminMutation();
  const [updateSubAdmin] = useUpdateSubAdminMutation();
  const [getSubAdminById] = useLazyGetSubAdminByIdQuery();
  const [subAdminData, setSubAdminData] = useState<subAdminType>();
  const [permissions, setPermissions] = useState<DataType[]>([
    {
      _id: "1",
      label: "Manage Customers",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
    },
    {
      _id: "2",
      label: "Manage Categories",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
    },
    {
      _id: "3",
      label: "Manage Product Specifications",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
    },
    {
      _id: "4",
      label: "Inventory Management",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
    },
    {
      _id: "5",
      label: "Product Order Management",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
    },
    {
      _id: "6",
      label: "Manage Bulk orders",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: false,
    },
    {
      _id: "7",
      label: "Manage Payments",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      _id: "8",
      label: "Reports and Analytics",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      _id: "9",
      label: "Discount and Coupon Management",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      _id: "10",
      label: "Manage Geofence",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      _id: "11",
      label: "Manage Banners",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      _id: "12",
      label: "Manage Notifications",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      _id: "13",
      label: "Manage Factory Tour",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      _id: "14",
      label: "Manage CMS",
      isEdit: false,
      isView: false,
      isDelete: false,
      disabled: true,
    },
  ]);
  

  const fetchSubAdminById = async (id: string) => {
    try {
      const response = await getSubAdminById({ id }).unwrap();
      if (response?.statusCode === 200) {
        setSubAdminData(response?.data);
        setPhoneCode(response?.data?.countryCode || "+91");
        setImage(response?.data?.image || "");
        const modifiedArr2 = permissions.map((item) => {
          const foundItem = response?.data?.permissions?.find(
            (i: { label: string }) => i?.label === item.label,
          );
          if (foundItem) {
            return {
              ...item,
              isView: foundItem.isView,
              isEdit: foundItem.isEdit,
              isDelete: foundItem.isDelete,
            };
          }
          return item;
        });
        setPermissions(modifiedArr2);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const onSelectChange = (key: any, type: string) => {
    let idx = permissions.findIndex((obj) => obj.label === key.label);
    if (type === "addEdit") {
      permissions[idx].isEdit = !key.isEdit;
      if (key.isEdit) {
        permissions[idx].isView = true;
      } else {
        permissions[idx].isView = false;
      }
    } else if (type === "isview") {
      permissions[idx].isView = !key.isView;
    } else {
      permissions[idx].isDelete = !key.isDelete;
      if (key.isDelete) {
        permissions[idx].isView = true;
      } else {
        permissions[idx].isView = false;
      }
    }
    setPermissions([...permissions]);
  };
  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    setPhoneCode(country?.dialCode);
  };


  const label = { inputProps: { "aria-label": "Switch demo" } };


  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    const res = await UploadMedia(file);
    if (res?.statusCode === 200) {
      setImage(res?.data);
    } else {
      showError(res?.message);
    }
  };

 
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: subAdminData?.firstName || "",
      lastName: subAdminData?.lastName || "",
      email: subAdminData?.email || "",
      phone: subAdminData?.phone || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address",
        ),
      firstName: Yup.string()
        .required("First name is required")
        .min(3, "Minimum 3 characters are required")
        .max(30, "Maximum 30 character are allowed"),

      lastName: Yup.string()
        .min(2, "Minimum 2 characters are required")
        .max(30, "Maximum 30 character are allowed"),

      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),

      permissions: Yup.array().of(
        Yup.object().shape({
          isEdit: Yup.boolean(),
          isView: Yup.boolean(),
          isDelete: Yup.boolean(),
        })
      ).min(1, 'At least one module must be selected'),

    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);

      permissions?.length > 0 &&
        permissions.map((element) => {
          const obj = {
            label: element?.label,
            isEdit: element.isEdit,
            isView: element.isView,
            isDelete: element.isDelete,
          };
          if (obj) {
            newData?.push(obj);
            setNewData([...newData]);
          }
        });

      const selectedModules = newData.filter((element) => {
        return (
          element.isView === true ||
          element.isEdit === true ||
          element.isDelete === true
        );
      })
      if (selectedModules?.length === 0) {
        showError("Please allow permission for atleast one module ")
        return;
      }


      let body = {
        ...(values.email !== subAdminData?.email
          ? { email: values.email }
          : {}),
        ...(values.phone !== subAdminData?.phone ||
          phoneCode !== subAdminData?.countryCode
          ? { phone: values.phone }
          : {}),
        ...(values.phone !== subAdminData?.phone ||
          phoneCode !== subAdminData?.countryCode
          ? { countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode }
          : {}),

        email: formik.values.email,
        firstName: formik.values.firstName,
        lastName: formik.values.lastName,
        countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode,
        phone: formik.values.phone,
        image: image,
        permissions: newData.filter((element) => {
          return (
            element.isView === true ||
            element.isEdit === true ||
            element.isDelete === true
          );
        }),
        // appKey: new Date().toISOString(),
      };
      console.log(body, "body");


      if (id) {
        try {
          let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response = await updateSubAdmin({
            id: id,
            body: encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            showToast("Subadmin Updated Sucessfully");
            navigate("/manage-subAdmin");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
          console.log(error);
        }
      } else {
        try {
          let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
          const response = await addSubAdmin(encryptedBody).unwrap();
          if (response?.statusCode === 200) {
            showToast("Sub-admin Created Sucessfully");
            navigate("/manage-subAdmin");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
          console.log(error);
        }
      }
    },
  });


  useEffect(() => {
    if (id) {
      fetchSubAdminById(id);
    }
  },[])

  return (
    <>
      <div>
        <div className="main_loyout">
          <div className="dashboard">
            <h1 className="mn_hdng">
              {id ? "Edit Sub-Admin" : "Add Sub-Admin"}
            </h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-subAdmin");
              }}
            >
              Back
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">Image</Typography>
                    {image ? (
                      <div className="upload_image_preview">
                        <CardMedia component="img" image={image} alt="photo" />
                        <CancelIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            setImage("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={handleImageUpload}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              src={
                                image
                                  ? image
                                  : "/static/images/user_placeholder.png"
                              }
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Typography className="custom_label">First Name</Typography>
                    <TextField
                      className="text_field"
                      hiddenLabel
                      type={"text"}
                      name="firstName"
                      variant="outlined"
                      fullWidth
                      placeholder="First Name"
                      inputProps={{ maxLength: 30 }}
                      id="firstName"
                      onBlur={formik.handleBlur}
                      value={formik.values.firstName}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.firstName && formik.errors.firstName
                      }
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Typography className="custom_label">Last Name</Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="lastName"
                      variant="outlined"
                      fullWidth
                      placeholder="Last Name"
                      id="lastName"
                      className="text_field"
                      inputProps={{ maxLength: 30 }}
                      onBlur={formik.handleBlur}
                      value={formik.values.lastName}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.lastName && formik.errors.lastName
                      }
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Typography className="custom_label">Email</Typography>
                    <TextField
                      className="text_field"
                      hiddenLabel
                      type={"email"}
                      name="email"
                      variant="outlined"
                      fullWidth
                      placeholder="Email"
                      id="email"
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <Typography className="custom_label">
                      Phone Number
                    </Typography>
                    <PhoneInput
                      enableSearch={true}
                      value={phoneCode + formik.values.phone}
                      country={"us"}
                      inputClass="phoneInput"
                      placeholder="Phone Number"
                      inputStyle={{ width: "100%" }}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <h6 className="err_msg">
                        {formik.touched.phone && formik.errors.phone}
                      </h6>
                    ) : (
                      ""
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <TableContainer className="table_container">
                      <Box className="heading"></Box>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="mn_hdng" align="center">
                              Module
                            </TableCell>
                            <TableCell className="mn_hdng" align="center">
                              Add/Edit
                            </TableCell>
                            <TableCell className="mn_hdng" align="center">
                              View
                            </TableCell>
                            <TableCell className="mn_hdng" align="center">
                              Delete
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {permissions.map((row, i) => (
                            <TableRow>
                              <TableCell className="mn_hdng">
                                {row.label}
                              </TableCell>
                              <TableCell align="center">
                                <Checkbox
                                  {...label}
                                  onChange={() =>
                                    onSelectChange(row, "addEdit")
                                  }
                                  checked={row?.isEdit || false}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Checkbox
                                  {...label}
                                  onChange={() => onSelectChange(row, "isview")}
                                  checked={row?.isView || false}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Checkbox
                                  {...label}
                                  onChange={() => onSelectChange(row, "isdel")}
                                  checked={row?.isDelete || false}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AddSubAdmin;
